<div class="bk-dialog">

	<button class="bk-modal__close_btn"
        (click)="close()"
        type="button">
        <mat-icon>close</mat-icon>
    </button>

	<h4 mat-dialog-title
		*ngIf='fertilizer && id'>
		{{'Edit' | translate }} {{ fertilizer.Name }}
	</h4>

	<h4 mat-dialog-title
		*ngIf='!id'>
		{{'Create' | translate }} {{ 'fertilizer' | translate }}
	</h4>

	<div mat-dialog-content
		*ngIf='fertilizer'>
		<fertilizer-edit [fertilizer]='fertilizer'
			[showMineralizationFields]='showMineralizationFields'
			(form)='updateFormState($event)'>
		</fertilizer-edit>
	</div>

	<div mat-dialog-actions align="end">

		<button mat-button
			*ngIf='!usage' 
			class="bk-button__delete bk-button--float-left"
			(click)="delete()">
			{{'Remove Fertilizer' | translate }}
		</button>

		<button mat-button
			class="bk-button bk-button--medium
			bk-button--text-only bk-dialog__button--secondary"
			(click)="close()">
			{{'Cancel' | translate }}
		</button>

		<button matt-button
			[disabled]="isFormValid === false"
			class="bk-button bk-button--medium"
			(click)="save()">
			{{'Save Changes' | translate }}
		</button>
	</div>
</div>